import React, { useContext } from "react";
import { Link, NavLink,useLocation } from "react-router-dom";
import { AppContext } from "../util/AppContext";

const Sidebar = () => {
  const { logout, user } = useContext(AppContext)
  const location = useLocation();
  const isOrdersActive = location.pathname.startsWith("/orders") || location.pathname.startsWith("/order-detail");

  return (
    <>
      <div className="sidebar-overlay">
        <section className="sidebar">
          <Link to="/" className="logo">
            <img className="" src={require("../assets/images/V2A_home.png")} alt="" />
          </Link>

          <div className="under-tabs">
            <NavLink to="/home" className={({ isActive }) => 'sidebar_option' + (isActive ? ' active' : '')}>
              <img src={require("../assets/images/dashboard-1.svg").default} />
              Dashboard
            </NavLink>

            <NavLink to="/users" className={({ isActive }) => 'sidebar_option' + (isActive ? ' active' : '')}>
              <img src={require("../assets/images/user-management.svg").default} />
              User Management
            </NavLink>

            <NavLink to="/category" className={({ isActive }) => 'sidebar_option' + (isActive ? ' active' : '')}>
              <img src={require("../assets/images/category-management.svg").default} />
              Category Management
            </NavLink>

            <NavLink to="/products" className={({ isActive }) => 'sidebar_option' + (isActive ? ' active' : '')}>
              <img src={require("../assets/images/product-management.svg").default} />
              Product Management
            </NavLink>

            <NavLink to="/orders" className={() => 'sidebar_option' + (isOrdersActive ? ' active' : '')}>
              <img src={require("../assets/images/order-management.svg").default} />
              Order Management
            </NavLink>

            <NavLink to="/enquiry" className={({ isActive }) => 'sidebar_option' + (isActive ? ' active' : '')}>
              <img src={require("../assets/images/enquiry management.svg").default} />
              Enquiry Management
            </NavLink>

            <NavLink to="/transactions" className={({ isActive }) => 'sidebar_option' + (isActive ? ' active' : '')}>
              <img src={require("../assets/images/transacation-management.svg").default} />
              Transaction Management
            </NavLink>

            <NavLink to="/contact-us" className={({ isActive }) => 'sidebar_option' + (isActive ? ' active' : '')}>
              <img src={require("../assets/images/contactus.svg").default} />
              Help & Support
            </NavLink>

            <NavLink to="/settings" className={({ isActive }) => 'sidebar_option' + (isActive ? ' active' : '')}>
            <i class="fa fa-cog" aria-hidden="true"></i>
              Configuration
            </NavLink>
          

            <Link className={"sidebar_option"} onClick={logout}>
              <img src={require("../assets/images/sign-out.svg").default} />
              Logout
            </Link>
          </div>

          <div className="sidebar-footer">

          </div>
        </section>
      </div>
    </>
  );
};
export default Sidebar;
